import { render, staticRenderFns } from "./SettingClinic.vue?vue&type=template&id=2affae04&"
import script from "./SettingClinic.vue?vue&type=script&lang=ts&"
export * from "./SettingClinic.vue?vue&type=script&lang=ts&"
import style0 from "./SettingClinic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports